import Decorator from '../decorator'

export default class PublishedListViewDecorator extends Decorator {
}